var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { C } from '#integrations';
import { RadioTestIdFactory } from '../../interactions';
import { RADIO_GROUP_ITEM_KINDS } from '../../Radio.constants';
import styles from './RadioInput.module.css';
const KIND_AVAILABILITY_CLASS_MAP = {
    default: {
        disabled: styles.DefaultDisabled,
        enabled: styles.Default,
    },
    // TODO(LUCID-35141): enabled and disabled classes are swapped for the compact kind.
    compact: {
        disabled: styles.Compact,
        enabled: styles.CompactDisabled,
    },
};
export const RadioInput = ({ 'aria-describedby': ariaDescribedBy, 'aria-errormessage': ariaErrorMessage, 'aria-invalid': ariaInvalid, 'data-testid': testid, description, disabled, id, kind = RADIO_GROUP_ITEM_KINDS.Default, label, name, onBlur, onChange, onFocus, ref, required, selectedValue, value, }) => {
    _react_refresh_temp_2();
    const isChecked = selectedValue === value;
    const [isFocused, setIsFocused] = useState(false);
    const containerStyle = C(styles.Container, KIND_AVAILABILITY_CLASS_MAP[kind][disabled ? 'disabled' : 'enabled'], isChecked && styles.ContainerChecked, disabled && styles.Disabled);
    const labelStyle = styles.Label;
    const radioWrapperStyle = C(styles.RadioWrapper, isChecked && styles.RadioWrapperChecked, isFocused && styles.RadioWrapperFocused, isChecked && disabled && styles.RadioWrapperCheckedDisabled);
    return (_jsxs("label", { className: containerStyle, "data-testid": RadioTestIdFactory.getRadioInputContainerTestId(testid), children: [_jsx("span", { className: radioWrapperStyle, children: _jsx("input", { checked: isChecked, className: C(styles.Radio, isChecked && styles.RadioChecked, isChecked && disabled && styles.RadioCheckedDisabled), "data-testid": RadioTestIdFactory.getRadioInputInputTestId(testid), disabled: disabled, id: id, name: name, onBlur: (event) => {
                        setIsFocused(false);
                        if (onBlur) {
                            onBlur(event);
                        }
                    }, onChange: (event) => {
                        if (event.target.checked) {
                            onChange(value);
                        }
                    }, onFocus: (event) => {
                        setIsFocused(true);
                        if (onFocus) {
                            onFocus(event);
                        }
                    }, ref: ref, required: required, type: "radio", value: value, ...(ariaDescribedBy && {
                        'aria-describedby': ariaDescribedBy,
                    }), ...(ariaErrorMessage && {
                        'aria-errormessage': ariaErrorMessage,
                    }), ...(ariaInvalid && { 'aria-invalid': true }) }) }), _jsxs("span", { className: styles.Details, children: [_jsx("span", { className: labelStyle, children: label }), description ? (_jsx("span", { className: styles.Description, "data-testid": RadioTestIdFactory.getRadioInputDescriptionTestId(testid), children: description })) : null] })] }));
};
_react_refresh_temp_1 = RadioInput;
$RefreshReg$(_react_refresh_temp_1, "RadioInput");
_react_refresh_temp_2(RadioInput, "taoS6m9NZex5dx3pinefKTdpShE=");
